import React from "react";

const ImpactTemplate = ({ candidateData }) => {
    // Default sample data matching your Flutter structure
    const defaultData = {
        name: "RICHARD SANCHEZ",
        title: "MARKETING MANAGER",
        phone: "+91 860255764",
        email: "Richard@gmail.com",
        linkedin: "Linkedin.in/NoorAlam/",
        profile: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation. Ut enim ad minim veniam quis nostrud exercitation.",
        professional_experience: [
            {
                period: "2030 - PRESENT",
                position: "Marketing Manager & Specialist",
                company: "Borsella Studio",
                achievements: [
                    "Develop and execute comprehensive marketing strategies and campaigns that align with the company's goals and objectives.",
                    "Lead, mentor, and manage a high-performing marketing team, fostering a collaborative and tosaltable driver work environment.",
                    "Monitor brand consistency across marketing channels and materials."
                ]
            }
        ],
        education: [
            {
                period: "2028 - 2029",
                degree: "Barbatar of Business",
                school: "WARDIGRE UNIVERSITY",
                gpa: "GPA: 3.8 / 4.0"
            }
        ],
        skills: [
            "Project Management",
            "Public Relations",
            "Teamwork",
            "Time Management",
            "Leadership",
            "Effective Communication",
            "Critical Thinking"
        ],
        languages: [
            { language: "English", proficiency: "Fluent" },
            { language: "French", proficiency: "Patent" },
            { language: "German", proficiency: "Banca" },
            { language: "Spanish", proficiency: "Informatista" }
        ],
        projects: [
            {
                name: "Ecommerce",
                period: "Feb 2025 - Present",
                description: [
                    "Designed wireframes and mockups for product pages",
                    "Ensured responsive layouts across mobile and tablet devices",
                    "Improved checkout flow to reduce cart abandonment",
                    "Worked closely with the team to maintain design consistency"
                ],
                role: "Designer",
                technologies: "Android, Java",
                team_size: 3
            },
            {
                name: "E commerce MERN Stacks",
                period: "Jun 2021 - Present",
                description: [
                    "Designed wireframes and mockups for product pages",
                    "Ensured responsive layouts across devices",
                    "Improved checkout flow for better user experience",
                    "Implemented responsive design techniques for cross-browser compatibility"
                ],
                role: "Front End Developer",
                technologies: "CSS, JavaScript",
                team_size: 10
            },
            {
                name: "Social Media Platform",
                period: "Jan 2023 - Dec 2023",
                description: [
                    "Built user-friendly feed and profile pages",
                    "Integrated real-time chat and notifications",
                    "Developed secure authentication and authorization",
                    "Enhanced UI for better engagement and retention"
                ],
                role: "Full Stack Developer",
                technologies: "React, Node.js, MongoDB, Express",
                team_size: 6
            }
        ],
        certifications: [
            {
                name: "AWS",
                number: "34799",
                url: "w.rhjgh.com",
                date: "2025-07-15"
            },
            {
                name: "Salesforce",
                number: "12345",
                url: "www.sahcshj.com",
                date: "2025-08-07"
            }
        ]
    };

    // Use provided data or default data
    const resumeData = candidateData ? mapCandidateData(candidateData) : defaultData;

    return (
        <div
            className="w-[210mm] h-[297mm] mx-auto bg-white text-gray-900 overflow-hidden relative p-4"
            style={{
                fontFamily: 'Arial, sans-serif',
                fontSize: '14px',
                lineHeight: '1.4'
            }}
        >
            {/* Purple Gradient Header - Full Width */}
            <div
                className="w-full py-4 px-3 text-center text-white"
                style={{
                    background: 'linear-gradient(90deg, #7c3aed 0%, #a855f7 100%)',
                    marginLeft: '-1rem',
                    marginRight: '-1rem',
                    marginTop: '-1rem'
                }}
            >
                {/* Name */}
                <h1 className="text-2xl font-bold mb-1" style={{ letterSpacing: '0.02em' }}>
                    {resumeData.name}
                </h1>

                {/* Title */}
                <p className="text-xs mb-2.5 opacity-95">
                    {resumeData.title}
                </p>

                {/* Contact Info in single centered line */}
                <p className="text-xs opacity-90" style={{ fontSize: '10px' }}>
                    Phone: {resumeData.phone}  |  Email: {resumeData.email}  |  Linkedin: {resumeData.linkedin}
                </p>
            </div>

            {/* Main Content - Two Column Layout */}
            <div className="flex gap-2.5 mt-2" style={{ height: 'calc(100% - 120px)' }}>
                {/* Left Column - Main Content (Profile + Experience + Projects) */}
                <div className="flex-1" style={{ flex: '3' }}>
                    {/* Profile Section */}
                    <div className="mb-1.5">
                        <h2 className="text-xs font-bold text-purple-800 mb-1">Profile</h2>
                        <div className="border-b border-purple-200 mb-1.5" style={{ borderWidth: '1px' }}></div>
                        <p className="text-xs leading-relaxed text-black text-justify" style={{ fontSize: '9px', lineHeight: '1.4' }}>
                            {resumeData.profile}
                        </p>
                    </div>

                    {/* Work Experience */}
                    <div className="mb-1.5">
                        <h2 className="text-xs font-bold text-purple-800 mb-1">Work Experience</h2>
                        <div className="border-b border-purple-200 mb-1.5" style={{ borderWidth: '1px' }}></div>
                        <div className="space-y-3.5">
                            {resumeData.professional_experience.map((exp, index) => (
                                <div key={index}>
                                    <div className="flex items-baseline mb-0.5">
                                        <h3 className="text-xs font-bold text-purple-700">
                                            {exp.company}
                                        </h3>
                                        <div className="ml-3 w-24">
                                            <span className="text-xs font-bold text-black">
                                                {exp.period}
                                            </span>
                                        </div>
                                    </div>
                                    <p className="text-xs text-black mb-2">
                                        {exp.position}
                                    </p>
                                    <ul className="space-y-1">
                                        {exp.achievements.map((achievement, i) => (
                                            <li key={i} className="text-xs leading-relaxed text-black" style={{ fontSize: '10px', lineHeight: '1.5' }}>
                                                - {achievement}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Projects */}
                    <div>
                        <h2 className="text-xs font-bold text-purple-800 mb-1">Projects</h2>
                        <div className="border-b border-purple-200 mb-1.5" style={{ borderWidth: '1px' }}></div>
                        <div className="space-y-3.5">
                            {resumeData.projects.map((project, index) => (
                                <div key={index}>
                                    <div className="flex items-baseline mb-0.5">
                                        <h3 className="text-xs font-bold text-purple-700">
                                            {project.name}
                                        </h3>
                                        <div className="ml-3 w-30">
                                            <span className="text-xs font-bold text-black">
                                                {project.period}
                                            </span>
                                        </div>
                                    </div>
                                    <p className="text-xs text-black font-bold mb-1.5">
                                        Role: {project.role}
                                    </p>
                                    <ul className="space-y-1 mb-1.5">
                                        {project.description.map((desc, i) => (
                                            <li key={i} className="text-xs leading-relaxed text-black" style={{ fontSize: '10px', lineHeight: '1.5' }}>
                                                - {desc}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="space-y-1">
                                       
                                        <p className="text-xs text-black" style={{ fontSize: '10px' }}>
                                            Team Size: {project.team_size}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Right Column - Purple Sidebar */}
                <div
                    className="bg-purple-50 rounded-lg p-2"
                    style={{ flex: '2', borderRadius: '8px' }}
                >
                    {/* Skills */}
                    <div className="mb-1">
                        <h3 className="text-xs font-bold text-purple-800 mb-1">Skills</h3>
                        <div className="border-b-2 border-purple-200 mb-1.5"></div>
                        <ul className="space-y-2">
                            {resumeData.skills.map((skill, idx) => (
                                <li key={idx} className="text-xs text-black" style={{ fontSize: '11px' }}>
                                    - {skill}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Education */}
                    <div className="mb-1">
                        <h3 className="text-xs font-bold text-purple-800 mb-1">Education</h3>
                        <div className="border-b-2 border-purple-200 mb-1.5"></div>
                        <div className="space-y-3.5">
                            {resumeData.education.map((edu, idx) => (
                                <div key={idx}>
                                    <p className="text-xs font-bold text-black mb-1" style={{ fontSize: '11px' }}>
                                        {edu.period}
                                    </p>
                                    <p className="text-xs font-bold text-black mb-1">
                                        {edu.school}
                                    </p>
                                    <p className="text-xs text-black mb-1" style={{ fontSize: '11px' }}>
                                        {edu.degree}
                                    </p>
                                    <p className="text-xs text-black" style={{ fontSize: '11px' }}>
                                        {edu.gpa}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Languages */}
                    <div className="mb-1">
                        <h3 className="text-xs font-bold text-purple-800 mb-1">Languages</h3>
                        <div className="border-b-2 border-purple-200 mb-1.5"></div>
                        <ul className="space-y-2">
                            {resumeData.languages.map((lang, idx) => (
                                <li key={idx} className="text-xs text-black" style={{ fontSize: '11px' }}>
                                    - {lang.language} ({lang.proficiency})
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Certifications */}
                    <div>
                        <h3 className="text-xs font-bold text-purple-800 mb-1">Certifications</h3>
                        <div className="border-b-2 border-purple-200 mb-1.5"></div>
                        <div className="flex flex-wrap gap-3">
                            {resumeData.certifications.map((cert, idx) => (
                                <div key={idx} className="flex-1 min-w-0 mb-2.5">
                                    <p className="text-xs font-bold text-purple-700 mb-0.5">
                                        {cert.name}
                                    </p>
                                    <p className="text-xs text-black mb-0.5" style={{ fontSize: '10px' }}>
                                        Certification #: {cert.number}
                                    </p>
                                    <p className="text-xs text-black mb-0.5" style={{ fontSize: '10px' }}>
                                        Date: {cert.date}
                                    </p>
                                    <a
                                        href={safeUrl(cert.url)}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-xs text-blue-600 underline break-all"
                                        style={{ fontSize: '10px' }}
                                    >
                                        {cert.url}
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Helper function to map candidateData to the expected format
const mapCandidateData = (candidateData) => {
    const {
        name,
        email,
        phone,
        basic_details,
        employment,
        education,
        projects,
        certifications,
        it_skills,
        candidate_languages,
    } = candidateData;

    return {
        name: name || "RICHARD SANCHEZ",
        title: employment?.[0]?.job_title?.title || "MARKETING MANAGER",
        phone: phone || "+91 860255764",
        email: email || "Richard@gmail.com",
        linkedin: basic_details?.linkedin || "Linkedin.in/NoorAlam/",
        profile: basic_details?.profile_summery || "Lorem ipsum dolor sit amet...",
        professional_experience: employment?.map(job => ({
            period: formatPeriod(job?.start_year, job?.end_year),
            position: job.job_title?.title || "",
            company: job.current_company || "",
            achievements: job.job_profile ? job.job_profile.split("\n") : []
        })) || [],
        education: education?.map(edu => ({
            period: `${edu?.course_duration_start_year} - ${edu?.course_duration_end_year}`,
            degree: edu?.education_course?.title || "",
            school: edu?.insitute_university || "",
            gpa: edu?.marks ? `GPA: ${edu.marks}` : ""
        })) || [],
        skills: it_skills?.map(skill => skill?.skill?.title).filter(Boolean) || [],
        languages: candidate_languages?.map(lang => ({
            language: lang.language,
            proficiency: getLanguageProficiency(lang)
        })) || [],
        projects: projects?.map(project => ({
            name: project.project_tag || "",
            period: formatProjectDateRange(project?.start_date, project?.end_date),
            description: project.project_description ? project.project_description.split("\n") : [],
            role: project.role || "",
            technologies: project.technologies || "",
            team_size: project.team_size || ""
        })) || [],
        certifications: certifications?.map(cert => ({
            name: cert.certification_name || "",
            number: cert.certification_number || "",
            url: cert.certification_url || "",
            date: cert.certification_date || ""
        })) || []
    };
};

/* Helper Functions */
const formatPeriod = (start, end) => {
    const s = start ? String(start).trim() : "";
    const e = end ? String(end).trim() : "";
    if (s && e) return `${s} - ${e}`;
    if (s && !e) return `${s} - PRESENT`;
    return "";
};

const formatProjectDateRange = (startDate, endDate) => {
    const s = startDate ? new Date(startDate) : null;
    const e = endDate ? new Date(endDate) : null;
    const fmt = (d) =>
        d?.toLocaleDateString("en-US", { month: "short", year: "numeric" }) || "";
    if (s && e) return `${fmt(s)} - ${fmt(e)}`;
    if (s && !e) return `${fmt(s)} - Present`;
    return "";
};

const getLanguageProficiency = (lang) => {
    const abilities = [];
    if (lang?.can_read) abilities.push("read");
    if (lang?.can_write) abilities.push("write");
    if (lang?.can_speak) abilities.push("speak");
    if (abilities.length === 3) return "Fluent";
    if (abilities.length === 2) return "Intermediate";
    if (abilities.length === 1) return "Basic";

    // Special cases for the sample data
    if (lang.language === "French") return "Patent";
    if (lang.language === "German") return "Banca";
    if (lang.language === "Spanish") return "Informatista";

    return "Basic";
};

const safeUrl = (u) => {
    if (!u) return "#";
    return /^https?:\/\//i.test(u) ? u : `https://${u}`;
};

export default ImpactTemplate;